import styles from './TicketsDetails.module.css';
import { useContext, useEffect, useState } from 'react';
import { format } from 'date-fns';
import { useLocation } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { useTranslation } from 'react-i18next';
import { getDevice } from '../../helpers/device';
import { formatDateDefault, formatDatSemiShort, getLocale } from '../../helpers/dates';
import SpinnerLoader from '../Common/Spinner/SpinnerLoader';
import Header from '../Common/Header/Header';
import { WelletContext } from '../../context/WelletContext';
import { useSelector } from 'react-redux';
import { getImageSize } from '../../helpers/image';

const TicketsDetails = ({ lng, id }) => {
  const location = useLocation();
  const { t } = useTranslation();
  const language = useSelector((state) => state.app.language);
  const locale = getLocale(language);
  const welletContext = useContext(WelletContext);
  const queryParams = new URLSearchParams(location.search);
  const [reservation, setReservation] = useState(null);
  const [error, setError] = useState(null);
  const isIOS = getDevice() === 'iOS';
  const ticketId = queryParams.get('ticketId');
  const [currentPage, setCurrentPage] = useState(1);
  const [eventsTickets, setEventsTickets] = useState([]);
  const totalPages = eventsTickets?.tickets?.length || 1;
  const eventsDetails = async () => {
    try {
      const response = await welletContext.apis.tickets.get(
        `/reservation/customer/${ticketId}/details`,
      );
      setEventsTickets(response.data);
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  useEffect(() => {
    eventsDetails();
  }, []);

  const [isMounted, setIsMounted] = useState(false);
  const [addingToWallet, setAddingToWallet] = useState(false);

  const getTicketPositions = (eventsTickets, ticketId) => {
    const positions = {};
    let ticketIndex = -1;

    eventsTickets.tickets?.forEach((ticket, index) => {
      positions[ticket.id] = index;

      if (ticket.id === ticketId) {
        ticketIndex = index;
      }
    });

    return { positions, ticketIndex };
  };

  const { ticketIndex } = getTicketPositions(eventsTickets);

  useEffect(() => {
    setIsMounted(true);
  }, []);

  const downloadPKPass = (data) => {
    const { stream, type, fileName } = data;
    if (type === 'application/vnd.apple.pkpass') {
      const byteCharacters = atob(stream);
      const byteNumbers = Array.from(byteCharacters, (char) => char.charCodeAt(0));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type });
      const fileUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = fileUrl;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(fileUrl);
    } else {
      console.error('El tipo de archivo no es un PKPass.');
    }
  };

  const walletGoogle = async (token) => {
    try {
      const response = await welletContext.apis.tickets.get(`/google?token=${token}`);
      return response.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const walletApple = async (token) => {
    try {
      const response = await welletContext.apis.tickets.get(`/apple?token=${token}`);
      return response;
    } catch (error) {
      console.error(error);
    }
  };

  const handleWellet = async (tokenWellet) => {
    setAddingToWallet(true);
    try {
      if (isIOS) {
        const response = await walletApple(tokenWellet);
        downloadPKPass(response.data);
      } else if (isMounted) {
        const url = await walletGoogle(tokenWellet);
        if (url) {
          window.open(url);
        } else {
          console.error('No se recibió una URL válida de Google Wallet');
        }
      }
    } catch (error) {
      console.error('Error al agregar a la billetera:', error);
    } finally {
      setAddingToWallet(false);
    }
  };

  if (error) {
    return <div>Error: {error}</div>;
  }
  if (reservation) {
    return <SpinnerLoader />;
  }

  return (
    <>
      <div>
        <Header />
      </div>

      <div>
        <Swiper
          onSlideChange={(swiper) => setCurrentPage(swiper.activeIndex + 1)}
          initialSlide={ticketIndex}
          slidesPerView={1}
          pagination={{ clickable: true }}
        >
          {eventsTickets?.reservationType !== 'RESTAURANT' ? (
            eventsTickets?.tickets?.map((item, index) => (
              <SwiperSlide key={item.id}>
                <div>
                  <div className={`${styles.cardWrap}`}>
                    <div className={`${styles.card} ${styles.cardRight}`}>
                      <div>
                        <img
                          src={
                            getImageSize(eventsTickets.eventShow?.imageUrl, 'medium') ||
                            eventsTickets.restaurantBanner
                          }
                          alt='Banner'
                          className={styles.banner}
                        />
                        <div className='d-flex flex-column mt-3'>
                          <span className={`${styles.title} fw-bold`}>
                            {eventsTickets.eventShow.name}
                          </span>
                          <span className='text-secondary semi-bold font-1rem'>
                            {item.showName}
                          </span>
                          <div className={`text-secondary font-smaller mt-1`}>
                            {formatDatSemiShort(eventsTickets.eventShow.startDate, locale)} ~{' '}
                            {eventsTickets.restaurantName}
                          </div>
                          <div className={styles.lineLightGrey}></div>

                          <div className='row mt-2'>
                            <div className='col-7'>
                              <div>
                                <div className={`font-extra-small text-secondary`}>
                                  Ticket / Zona
                                </div>
                                <div className={`${styles.colorBlack} font-tiny  bold mt-1`}>
                                  {item.ticketName}
                                </div>
                              </div>
                            </div>

                            <div className='col-5'>
                              <div className={`font-extra-small text-secondary`}>Order Number</div>
                              <div className={`${styles.colorBlack} font-tiny mt-1  bold`}>
                                {item.individualReferenceCode}
                              </div>
                            </div>
                          </div>

                          <div class='row mt-3'>
                            <div class='col-7 '>
                              <div>
                                <div className={`font-extra-small text-secondary`}>Date</div>
                                <div
                                  className={`${styles.colorBlack} bold mt-1`}
                                  style={{ fontFamily: 'sans-serif' }}
                                >
                                  {formatDateDefault(eventsTickets.eventShow.startDate, locale)}
                                </div>
                              </div>
                            </div>

                            <div class='col-5 '>
                              <div>
                                <div className={`font-extra-small text-secondary`}>Time</div>
                                <div className={`${styles.colorBlack} bold mt-1`}>
                                  {`${format(
                                    new Date(eventsTickets.eventShow.startDate),
                                    'h:mm a',
                                  )}`}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={`${styles.card} ${styles.cardMid}`}>
                      <div className={styles.qrContainer}>
                        {item.url && <img src={item.url} alt='QR' />}
                      </div>

                      <div className={`${styles.individualReferenceCode} text-center`}>
                        {t('scanRWntryGate')}
                      </div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))
          ) : (
            <SwiperSlide key={eventsTickets.id} className={styles.containerSwiper}>
              <div>
                <div className={`${styles.cardWrap}`}>
                  <div className={`${styles.card} ${styles.cardRight}`}>
                    <div>
                      <img
                        src={eventsTickets.restaurantBanner}
                        alt='Banner'
                        className={styles.banner}
                      />
                      <div className='d-flex flex-column mt-3'>
                        <span className={`${styles.title} fw-bold`}>
                          {eventsTickets.restaurantName}
                        </span>
                        <span className='text-secondary semi-bold font-1rem'>
                          {eventsTickets.showName}
                        </span>

                        <div
                          className={`text-secondary font-extra-small mt-1`}
                          style={{ fontFamily: 'sans-serif' }}
                        >
                          {formatDatSemiShort(eventsTickets.reservationLocalTime, locale)} ~{' '}
                          {eventsTickets.restaurantName}
                        </div>
                        <div className={styles.lineLightGrey}></div>

                        <div className='row mt-2'>
                          <div className='col-7'>
                            <div>
                              <div className={`font-extra-small text-secondary`}>{t('holder')}</div>
                              <div className={`${styles.colorBlack} font-tiny bold mt-1`}>
                                {eventsTickets.customerName}
                              </div>
                            </div>
                          </div>

                          <div className='col-5'>
                            <div className={`font-extra-small text-secondary`}>{t('peoples')}</div>
                            <div className={` ${styles.colorBlack}  font-tiny bold mt-1`}>
                              {eventsTickets.pax}
                            </div>
                          </div>
                        </div>

                        <div class='row mt-3'>
                          <div class='col-7 '>
                            <div>
                              <div className={`font-extra-small text-secondary`}>Date</div>
                              <div
                                className={`${styles.colorBlack}  bold mt-1`}
                                style={{ fontFamily: 'sans-serif' }}
                              >
                                {formatDateDefault(eventsTickets.reservationLocalTime, locale)}
                              </div>
                            </div>
                          </div>

                          <div class='col-5 '>
                            <div>
                              <div className={`font-extra-small text-secondary`}>Time</div>
                              <div className={`${styles.colorBlack} bold mt-1`}>
                                {`${format(
                                  new Date(eventsTickets.reservationLocalTime),
                                  'h:mm a',
                                )}`}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.card} ${styles.cardMid}`}>
                    <div className={styles.qrContainer}>
                      {eventsTickets.url && <img src={eventsTickets.url} alt='QR' />}
                    </div>
                    {eventsTickets.referenceCode && (
                      <div className={`${styles.containerReferentCode}  bold text-center`}>
                        {eventsTickets.referenceCode}
                      </div>
                    )}
                    <div className={`${styles.individualReferenceCode} text-center`}>
                      {t('scanRWntryGate')}
                    </div>
                  </div>
                </div>
              </div>
            </SwiperSlide>
          )}
        </Swiper>
        <div className={styles.pageIndicator}>
          e-ticket {currentPage} {t("or")} {totalPages}
        </div>
      </div>
    </>
  );
};

export default TicketsDetails;
